import styled, { css } from 'styled-components';

import { UpdateMessage } from 'libs/ui';

export const UpdateMessageStyled = styled(UpdateMessage)`
  top: 480px;
  left: 33%;
`;

export const ToggleBox = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  display: flex;
  align-items: center;
  p {
    font-size: 15px;
    &:first-child {
      color: #d33d34;
    }
    &:last-child {
      color: #dde3e7;
    }
  }

  &.active {
    p {
      &:first-child {
        color: #dde3e7;
      }
      &:last-child {
        color: #17b26e;
      }
    }
  }

  &.v2 {
    p {
      &:first-child {
        color: #d33d34;
      }
      &:last-child {
        color: #666;
      }
    }
    &.active {
      p {
        &:first-child {
          color: #666;
        }
        &:last-child {
          color: #17b26e;
        }
      }
    }
  }
`;

export const Toggle = styled.div`
  width: 38px;
  height: 20px;
  cursor: pointer;
  border-radius: 21px;
  background-color: ${(props) => (props.isActive ? '#17b26e' : '#d33d34')};
  margin: 0 15px;
  padding: 1px;
  div {
    position: relative;
    width: 18px;
    height: 18px;
    background-color: #ffffff;
    border-radius: 50%;
    transition: all 0.2s;
    left: ${(props) => (props.isActive ? '18px' : '0')};
  }
  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
`;
